export default "__VITE_ASSET__CTxGf6s8__"